<template>
  <ExActionsPopUp
    :value="show"
    headline="Detach Employee Access"
    :avatar="avatar"
    :htmlInfo="info"
    :destructive="true"
    actionLabel="Detach Access"
    :centerHeadline="true"
    @onAction="emit('onAction', $event)"
    @input="emit('onClose')"
  >
  </ExActionsPopUp>
</template>

<script>
export default {
  name: "DetachEmployeeAccessDialog",
};
</script>

<script setup>
import { computed } from "vue";
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  avatar: {
    type: Object,
    required: true,
  },
  full_name: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(["onAction", "onClose"]);

const info = computed(
  () =>
    `Employee ${props.full_name} is about to be detached from its access permissions to this account.<br><br>This action is irreversible.<br><br>`
);
</script>

<style scoped>
::v-deep .action_popup_title.title-align-center {
  color: #000000 !important;
  margin-bottom: 2rem !important;
}

::v-deep .action_popup_message.message-spaced {
  text-align: center;
  display: block;
  line-height: 1.5 !important;
}
</style>
